export default __webpack_public_path__ + "static/media/prev-IVTS-3.e061fc05.png";